import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(app)/play/friend/page.tsx");
